/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// actions and reducers used to manipulate application state
import { createEmbed, updateEmbed } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { moveToLibraryWithFetch } from 'state/actions/embedsState/embeds_status';
import { resetEmbedState } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { setEditMode } from 'state/actions/app_status';
// utils
import { batchActions } from "redux-batched-actions";
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import EmbedManagement from 'pages/dashboard/embeds/management/embed_management';
// import { batchActions } from "redux-batched-actions/lib/index";



/* ========== ~~~~~~~~~~ EMBED MANAGEMENT: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    isDataReceived: embedsState.embedsStatus.isDataReceived,
    currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    embedName: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedName,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    executorUUID: !!sessionStatus.executorUUID ? sessionStatus.executorUUID : 'none',
    selectedEmbedStatus: embedsState.embedManagementState.selectedEmbedStatus,
    contentStatus: embedsState.embedManagementState.contentStatus,
    isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
    // isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
    changeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
        embedsState.embedManagementState.contentStatus.contentChangeDetected
});
// map actions
const mapDispatchToProps = dispatch => ({
    createEmbed: (siteUUID, data) => dispatch(createEmbed(siteUUID, data)),
    updateEmbed: (siteUUID, embedUUID, data) => dispatch(updateEmbed(siteUUID, embedUUID, data)),
    updateStepDetails: location => dispatch(updateStepDetails(location)),
    setEditMode: editState => dispatch(setEditMode(editState)),
    moveToLibraryWithFetch: accountUUID => dispatch(moveToLibraryWithFetch(accountUUID)),
    resetEmbedAndContentState: () => dispatch(batchActions([
        resetEmbedState(),
        resetContentState({ setInitialContentId: false }),
    ]))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(EmbedManagement));
